import React from 'react';
import SerpComparison from './components/SerpComparison';

function App() {
  return (
    <div className="App">
      <SerpComparison />
    </div>
  );
}

export default App;
